import { css } from '@inter-ikea-kompis/web-component';
const BUTTON_MAX_WIDTH = 360;
const SHEET_WIDTH_SIZE_MEDIUM = 560;
export default class SheetFooterButtonsStyle {
    /**
     * Returns styles.
     *
     * @param options Options Object.
     * @param options.theme Theme.
     * @param options.hasSecondaryButton Secondary button.
     * @param options.compact ...
     * @param options.container.clientWidth Client width.
     * @param options.container.offsetWidth Offset width.
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing } = options.theme;
        const primaryButtonMargin = `${options.hasSecondaryButton && !options.compact ? spacing.space100 / 16 : 0}rem;`;
        return css `
			:host {
				display: flex;
				width: 100%;
			}
			.container {
				display: flex;
				flex-grow: 1;
				flex-direction: ${options.compact ? 'row-reverse' : 'column'};
			}
			skapa-button {
				max-width: ${options.compact || options.containerRect.width >= SHEET_WIDTH_SIZE_MEDIUM
            ? BUTTON_MAX_WIDTH / 16 + 'rem'
            : '100%'};
			}
			.divider {
				width: ${(options.compact ? spacing.space75 : spacing.space100) / 16}rem;
				flex-shrink: 0;
			}
			@media screen and (max-width: ${(SHEET_WIDTH_SIZE_MEDIUM - 1) / 16}rem) {
				.primaryButton {
					margin-bottom: ${primaryButtonMargin};
				}
			}
			@media screen and (min-width: ${SHEET_WIDTH_SIZE_MEDIUM / 16}rem) {
				.container {
					flex-direction: ${options.containerRect.width <= SHEET_WIDTH_SIZE_MEDIUM &&
            !options.compact
            ? 'column'
            : 'row-reverse'};
					justify-content: start;
				}
				.primaryButton {
					margin-bottom: ${primaryButtonMargin};
				}
			}
		`;
    }
}
//# sourceMappingURL=SheetFooterButtonsStyle.js.map